import { useEffect, useRef, useState } from "react";
const useImagePreload = (src, options)=>{
    const [status, setStatus] = useState('idle');
    const abortControllerRef = useRef(null);
    const onLoadRef = useRef(null == options ? void 0 : options.onLoad);
    const { enabled, cache } = null != options ? options : {};
    useEffect(()=>{
        onLoadRef.current = null == options ? void 0 : options.onLoad;
    }, [
        null == options ? void 0 : options.onLoad
    ]);
    useEffect(()=>{
        if (!src || false === enabled) return void setStatus('idle');
        if (null == cache ? void 0 : cache.current[src]) return void setStatus('complete');
        abortControllerRef.current = new AbortController();
        const { signal } = abortControllerRef.current;
        const img = new Image();
        img.onloadstart = ()=>{
            if (signal.aborted) return;
            setStatus('loading');
        };
        img.onload = (event)=>{
            var _onLoadRef_current;
            if (signal.aborted) return;
            setStatus('complete');
            null == (_onLoadRef_current = onLoadRef.current) || _onLoadRef_current.call(onLoadRef, event);
        };
        img.onerror = ()=>{
            if (signal.aborted) return;
            setStatus('failed');
        };
        img.src = src;
        return ()=>{
            var _abortControllerRef_current;
            null == (_abortControllerRef_current = abortControllerRef.current) || _abortControllerRef_current.abort();
            img.onloadstart = null;
            img.onload = null;
            img.onerror = null;
            img.src = '';
        };
    }, [
        src,
        enabled,
        cache
    ]);
    return status;
};
export { useImagePreload };
